import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-previous-meeting-history-dialog',
  templateUrl: './previous-meeting-history-dialog.component.html',
  styleUrls: ['./previous-meeting-history-dialog.component.css']
})
export class PreviousMeetingHistoryDialogComponent implements OnInit {

  options: any
  today : any
  currentDate : any

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';

  constructor(private dialog : MatDialog) { }

  ngOnInit(): void {
    this.options = {
      weekday : 'long',
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
  }
  closeDialog() {
    this.dialog.closeAll()
  }
}
